import { render, staticRenderFns } from "./companyhistory.vue?vue&type=template&id=42870694&"
import script from "./companyhistory.vue?vue&type=script&lang=js&"
export * from "./companyhistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports